import './scss/index.scss';
import ContentType from './js/content-type';

export {
    ContentType
};
